export function YogaMat() {
  return (
    <group>
      <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0, 0.001, 0]} receiveShadow>
        <planeGeometry args={[1.2, 2.4]} />
        <meshStandardMaterial color="#2d6a6a" roughness={0.9} metalness={0.05} transparent opacity={0.85} />
      </mesh>
      <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0, 0.002, 0]}>
        <planeGeometry args={[1.05, 2.2]} />
        <meshStandardMaterial color="#3d8a8a" roughness={0.95} transparent opacity={0.5} />
      </mesh>
    </group>
  )
}
